/**
 * Created by Alican Köker on 2018-08-23.
 */
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {TimelineLite, TweenLite} from "gsap";

enum States {
    enabled,
    disabled,
    active,
}

export class BonusMultiplier extends PIXI.Container {

    private _active:PIXI.Sprite;
    private _enabled:PIXI.Sprite;
    private _disabled:PIXI.Sprite;
    private _rays:PIXI.Sprite;
    private _state:States = States.disabled;
    private _text:PIXI.Text;
    private _value:number = 0;
    private _indicatorContainer:PIXI.Sprite;
    private _indicatorFrame:PIXI.Sprite;


    private _textStyle:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "24px",
        fontStyle : FontStyle.ITALIC,
        fontWeight : FontWeight.EXTRA_BOLD,
        fill : "#f9fe57",
        stroke : "#623d1b",
        strokeThickness : 7,
        align : "center",
    };

    constructor(index:number) {
        super();

        this.initMultiplier(index);
    }

    private initMultiplier(index:number):void {

        if(index > -1 && index < 3) {
            this._indicatorContainer = new PIXI.Sprite(GameResources.getTextures("indicatorBG_A")[0]);
        } else if(index > 2 && index < 6) {
            this._indicatorContainer = new PIXI.Sprite(GameResources.getTextures("indicatorBG_B")[0]);
        } else if(index > 5 && index < 8) {
            this._indicatorContainer = new PIXI.Sprite(GameResources.getTextures("indicatorBG_C")[0]);
        } else {
            this._indicatorContainer = new PIXI.Sprite(GameResources.getTextures("indicatorBG_D")[0]);
        }

        this.addChild(this._indicatorContainer);

        if(index === 9) {
            this._indicatorFrame = new PIXI.Sprite(GameResources.getTextures("indicatorBG")[0]);
            this._indicatorFrame.anchor.set(.5, .5);
            this._indicatorContainer.addChild(this._indicatorFrame);
        }
        this._enabled = new PIXI.Sprite(GameResources.getTextures("indicatorEnabled")[0]);
        this._enabled.anchor.set(.5, .5);
        this._enabled.position.set(0, 0);

        this._disabled = new PIXI.Sprite(GameResources.getTextures("indicatorDisabled")[0]);
        this._disabled.anchor.set(.5, .5);
        this._disabled.position.set(0, 0);

        this._active = new PIXI.Sprite(GameResources.getTextures("indicatorActive")[0]);
        this._active.anchor.set(.5, .5);
        this._active.position.set(0, 0);

        this._rays = new PIXI.Sprite(GameResources.getTextures("indicatorRays")[0]);
        this._rays.anchor.set(.5, .5);
        this._rays.position.set(0, 0);
        this._rays.scale.set(0);

        this._text = new PIXI.Text("X" + this._value.toString(), this._textStyle);
        this._text.anchor.set(.5, .5);
        this._text.position.set(0, 0);

        this._indicatorContainer.anchor.set(.5, .5);

        this._indicatorContainer.addChild(this._enabled);
        this._indicatorContainer.addChild(this._disabled);
        this._indicatorContainer.addChild(this._active);
        this._indicatorContainer.addChild(this._rays);
        this._indicatorContainer.addChild(this._text);
        this.addChild(this._indicatorContainer);
    }

    public setValue(value:number):void {
        this._value = value;
        this._text.text = "X" + value.toString();
    }

    public updateValue():void {
        this._text.updateTransform();
    }

    public enableMultiplier():void {
        this._disabled.visible = false;
        this._enabled.visible = true;
        this._active.visible = false;
        this._text.visible = true;
        this._text.alpha = 1;
        this._text.scale.set(1);
        this._state = States.enabled;
        this._text.style.fill = "#f9fe57";
        this._text.style.stroke = "#623d1b";
        this._text.style.fontSize = "24px";
        this._text.updateTransform();
    }

    public disableMultiplier():void {
        this._disabled.visible = true;
        this._enabled.visible = false;
        this._active.visible = false;
        this._text.visible = true;
        this._text.alpha = .65;
        this._text.scale.set(1);
        this._state = States.disabled;
        this._text.style.fill = "#f9fe57";
        this._text.style.stroke = "#623d1b";
        this._text.style.fontSize = "24px";
        this._text.updateTransform();
    }

    public activateMultiplier():void {
        this._enabled.visible = false;
        this._disabled.visible = false;
        this._active.visible = true;
        this._text.visible = true;
        this._text.alpha = 1;
        this._text.scale.set(1.4);
        this._state = States.active;
        this._text.style.fill = "#FFFFFF";
        this._text.style.stroke = "#561dba";
        this._text.style.fontSize = "30px";
        this._text.updateTransform();
    }

    public playHighlightAnimation(endState:string, value:number, last:boolean = false):TimelineLite {
        let valueToScale:number = last ? 2.5 : 1.4;

        let tl:TimelineLite = new TimelineLite();

        let stateToSet:void;

        switch(endState) {
            case "enabled":
                stateToSet = this.enableMultiplier();
                break;
            case "disabled":
                stateToSet = this.disableMultiplier();
                break;
            case "active":
                stateToSet = this.activateMultiplier();
                break;
            default:
                stateToSet = this.enableMultiplier();
                break;
        }

        tl.add(() => {
            TweenLite.to(this._indicatorContainer.scale, .1, {
                x : valueToScale, y : valueToScale, onComplete : () => {
                    if(endState === "active") {
                        this._rays.visible = true;
                        TweenLite.to(this._rays.scale, .1, {
                            x : 1, y : 1, onComplete : () => {
                                TweenLite.to(this._rays.scale, 1, {
                                    x : 0, y : 0, onComplete : () => {
                                        this._rays.visible = false;
                                    }
                                })
                            }
                        });
                    }
                    TweenLite.to(this._indicatorContainer.scale, .1, {
                        x : 1, y : 1, onComplete : () => {
                            () => stateToSet;
                            this.setValue(value);
                            this.updateValue();
                        }
                    });
                }
            })
        });

        return tl;
    }
}